export const CARD_CONTAINER_CLASS = " mx-3 border border-New_Primary_Default";
export const IMAGE_CONTAINER_CLASS = "w-full";
export const INNER_CARD_CONTAINER_CLASS =
    "p-4 lg:p-6  border-t border-New_Primary_Default";
